import { pageRoute } from "../routeFactory";

const HswPlanForeword = () => import("@/views/HswPlanForeword.vue");
const HswPrioritiesPage = () => import("@/views/HswPriorities.vue");
const SafetyCulturePage = () => import("@/views/SafetyCulturePage.vue");
const TechnologyInnovationPage = () =>
  import("@/views/TechnologyInnovationPage.vue");
const SafeDeliveryPage = () => import("@/views/SafeDelivery.vue");
const SucceedingPage = () => import("@/views/SuceedingPage.vue");
const HswAchievementsPage = () => import("@/views/HswAchievementsPage.vue");

const section = "hsw-plan";

export const hswPlanChildren = [
  pageRoute({
    path: "hsw-foreword",
    name: "HswForeword",
    component: HswPlanForeword,
    section,
    bodyClass: "hsw-foreword",
    titleKey: "nav.hsw-foreword",
  }),
  pageRoute({
    path: "hsw-priorities",
    name: "HswPriorities",
    component: HswPrioritiesPage,
    section,
    bodyClass: "hsw-priorities",
    titleKey: "nav.hsw-priorities",
  }),
  pageRoute({
    path: "safety-culture",
    name: "HswSafetyCulture",
    component: SafetyCulturePage,
    section,
    bodyClass: "safety-culture",
    titleKey: "nav.safety-culture",
  }),
  pageRoute({
    path: "technology-and-innovation",
    name: "HswTechInnovation",
    component: TechnologyInnovationPage,
    section,
    bodyClass: "technology-and-innovation",
    titleKey: "nav.technology-and-innovation",
  }),
  pageRoute({
    path: "safe-delivery",
    name: "HswSafeDelivery",
    component: SafeDeliveryPage,
    section,
    bodyClass: "safe-delivery",
    titleKey: "nav.safe-delivery",
  }),
  pageRoute({
    path: "are-we-succeeding",
    name: "HswSucceeding",
    component: SucceedingPage,
    section,
    bodyClass: "are-we-succeeding",
    titleKey: "nav.are-we-succeeding",
  }),
  pageRoute({
    path: "hsw-achievements",
    name: "HswAchievements",
    component: HswAchievementsPage,
    section,
    bodyClass: "hsw-achievements",
    titleKey: "nav.hsw-achievements",
  }),
];
